(function() {
  'use strict';

  const CONFIG = {
    debug: true,
    enabled: true,
    lazyLoadThreshold: 2,
    addDimensions: true,
    safeFormats: ['webp', 'avif', 'svg']
  };

  const state = {
    initialized: false,
    processed: 0,
    converted: 0,
    skipped: 0,
    alreadyOptimized: 0
  };

  function log(msg, type = 'info') {
    if (!CONFIG.debug) return;
    const style = {
      info: 'color:#2196F3;font-weight:bold;',
      success: 'color:#4CAF50;font-weight:bold;',
      warn: 'color:#FF9800;font-weight:bold;',
      error: 'color:#F44336;font-weight:bold;',
      header: 'background:#111;color:#fff;font-size:15px;padding:8px;font-weight:bold;'
    };
    console.log('%c' + msg, style[type] || style.info);
  }

  function getExtension(url) {
    if (!url) return '';
    return url.split('.').pop().split('?')[0].toLowerCase();
  }

  function isOptimizedFormat(url) {
    return CONFIG.safeFormats.some(ext => url.includes(ext));
  }

  function isShopifyUrl(url) {
    return url?.includes('cdn.shopify.com') || url?.includes('/cdn/shop/');
  }

  function createOptimizedURL(src) {
    if (!src) return src;

    // do NOT change webp/avif/svg
    if (isOptimizedFormat(src)) return src;

    // preserve PNG transparency → WebP
    if (src.includes('.png')) {
      return appendParam(src, 'format=webp');
    }

    // JPEG/JPG → Progressive JPEG
    if (src.match(/\.(jpg|jpeg)/i)) {
      return appendParam(src, 'format=pjpg&quality=80');
    }

    return src;
  }

  function appendParam(url, param) {
    return url.includes('?') ? `${url}&${param}` : `${url}?${param}`;
  }

  function addDimensions(img) {
    if (img.getAttribute('width') && img.getAttribute('height')) return;

    if (img.naturalWidth && img.naturalHeight) {
      img.setAttribute('width', img.naturalWidth);
      img.setAttribute('height', img.naturalHeight);
      return;
    }

    img.addEventListener('load', () => {
      if (!img.getAttribute('width')) img.setAttribute('width', img.naturalWidth);
      if (!img.getAttribute('height')) img.setAttribute('height', img.naturalHeight);
    }, { once: true });
  }

  function setLoadingBehavior(img, index) {
    if (index <= CONFIG.lazyLoadThreshold) {
      img.loading = 'eager';
      img.fetchPriority = index === 0 ? 'high' : 'auto';
    } else {
      img.loading = 'lazy';
      img.decoding = 'async';
    }
  }

  function processImage(img, index) {
    const src = img.getAttribute('src');

    if (!src || !isShopifyUrl(src)) {
      state.skipped++;
      return;
    }

    // do not touch images that are already modern formats
    if (isOptimizedFormat(src) || src.includes('format=')) {
      state.alreadyOptimized++;
      setLoadingBehavior(img, index);
      if (CONFIG.addDimensions) addDimensions(img);
      return;
    }

    // Apply optimization BEFORE loading
    const newSrc = createOptimizedURL(src);

    if (newSrc !== src) {
      img.setAttribute('src', newSrc);
      state.converted++;
      log(`Optimized: ${src.split('/').pop()} → ${newSrc.split('?')[1]}`, 'success');
    }

    // lazy/eager behavior
    setLoadingBehavior(img, index);

    // CLS prevention
    if (CONFIG.addDimensions) addDimensions(img);

    // missing alt text fix
    if (!img.alt) img.alt = img.title || 'Product Image';

    state.processed++;
  }

  function runOptimizer() {
    if (state.initialized) return;
    state.initialized = true;

    log('🚀 CRONY.AE SAFE IMAGE OPTIMIZER STARTED', 'header');

    const images = document.querySelectorAll('img');

    images.forEach((img, index) => {
      try { processImage(img, index); }
      catch (e) {
        log(`Error processing image: ${e.message}`, 'error');
      }
    });

    console.log('%cSUMMARY:', 'background:#4CAF50;color:#000;padding:6px;font-weight:bold;');
    console.log(`Processed: ${state.processed}`);
    console.log(`Converted: ${state.converted}`);
    console.log(`Already Optimized: ${state.alreadyOptimized}`);
    console.log(`Skipped: ${state.skipped}`);
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runOptimizer);
  } else {
    runOptimizer();
  }

  // Public control access
  window.CronySafeOptimizer = {
    rerun: runOptimizer,
    state
  };

})();
